import React from 'react';

import { TouchableOpacity, Text, Image } from 'react-native';
import menuIcon from '../assets/menu-icon@3x.png';

// NOTE(dave): The 'hitSlop' here may cause issues with the width of the cards
// in the navigation stack...
const MenuButton = ({ onPress, style = {} }) => (
    <TouchableOpacity
        onPress={onPress}
        hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
    >
        <Image
            resizeMode={Image.resizeMode.contain}
            source={{ uri: menuIcon }}
            style={[style, { width: 18, height: 18 }]}
        />
    </TouchableOpacity>
);

export default MenuButton;
